import { environment } from '@environment';

import { BusSearchPayload } from '@buses/bus-results/entities/bus-search-payload';
import { BusType } from '@search-bar/entities/bus-type';
import { getBaseRequestSettings } from '@app/mappers/reguest-settings.mapper';

export type Payload = Readonly<{
  adults: string,
  arrival: string,
  children: string,
  departure: string,
  departure_date: string,
  arrival_date?: string,
  bus_type: string,
  buss_class: string,
  infants: string,
  airline: string
  baggage_included: string
}>;

export function mapPayload(payload: Payload, isMobile: boolean): BusSearchPayload {
  const flightType = payload.bus_type.toUpperCase();
  if (flightType === BusType.ONEWAY.replace('_', '')) return mapForOneWay(payload, isMobile);
  if (flightType === BusType.ROUNDTRIP.replace('_', '')) return mapForRoundTrip(payload, isMobile);
}

function mapForOneWay(payload: Payload, isMobile: boolean): BusSearchPayload {
  return {
    Trips: [
      {
        DeparturePoint: payload.departure,
        ArrivalPoint: payload.arrival,
        DepartureDate: payload.departure_date,
        CabinCode: payload.buss_class,
        BaggageIncluded: payload.baggage_included ? JSON.parse(payload.baggage_included) : false,
        AirlineCode: payload.airline && payload.airline !== 'null' ? payload.airline : null
      }
    ],
    IsBusSearch: true,
    Adults: payload.adults,
    Children: payload.children,
    Infants: payload.infants,
    MaxResults: 0,
    RequestSettings: getBaseRequestSettings(isMobile),
    CurrencyCode: environment.countryInfo.currency_code
  };
}

function mapForRoundTrip(payload: Payload, isMobile: boolean): BusSearchPayload {
  return {
    Trips: [
      {
        DeparturePoint: payload.departure,
        ArrivalPoint: payload.arrival,
        DepartureDate: payload.departure_date,
        CabinCode: payload.buss_class,
        BaggageIncluded: payload.baggage_included ? JSON.parse(payload.baggage_included) : false,
        AirlineCode: payload.airline && payload.airline !== 'null' ? payload.airline : null
      },
      {
        DeparturePoint: payload.arrival,
        ArrivalPoint: payload.departure,
        DepartureDate: payload.arrival_date,
        CabinCode: payload.buss_class,
        BaggageIncluded: payload.baggage_included ? JSON.parse(payload.baggage_included) : false,
        AirlineCode: payload.airline && payload.airline !== 'null' ? payload.airline : null
      }
    ],
    IsBusSearch: true,
    Adults: payload.adults,
    Children: payload.children,
    Infants: payload.infants,
    MaxResults: 0,
    RequestSettings: getBaseRequestSettings(isMobile),
    CurrencyCode: environment.countryInfo.currency_code
  };
}
